import { UNKNOWN_ERROR } from '@/content';
import mixins from 'vue-typed-mixins';
import { mapActions } from 'vuex';
import accountLookupResultMixin from './accountLookupResultMixin';
import { getAccountType } from './helpers';
export default mixins(accountLookupResultMixin).extend({
    data: () => ({
        requestingPassword: false,
        alert: {
            message: '',
            type: '',
        },
        passwordSent: false,
    }),
    methods: {
        ...mapActions('accountLookup', ['lookup', 'requestPassword']),
        sendDetailToPhone() {
            this.sendDetail('', true);
        },
        async sendDetail(email, toPhone = false) {
            var _a, _b;
            this.requestingPassword = true;
            this.passwordSent = false;
            this.alert.message = '';
            this.alert.type = '';
            const method = toPhone ? 'phone' : 'email';
            try {
                const res = await this.requestPassword({
                    body: {
                        email: email || ((_a = this.firstAccount) === null || _a === void 0 ? void 0 : _a.email),
                        token: this.result.token,
                        type: getAccountType(),
                    },
                    method,
                });
                this.passwordSent = true;
                setTimeout(() => {
                    this.passwordSent = false;
                }, 10000);
                if (!res) {
                    this.alert.message = 'Network error';
                    this.alert.type = 'error';
                    return;
                }
                if (res.error) {
                    this.alert.message = ((_b = res.error) === null || _b === void 0 ? void 0 : _b.message) || UNKNOWN_ERROR;
                    this.alert.type = 'error';
                    return;
                }
                const methodText = method === 'phone' ? 'nomor handphone Anda' : 'email';
                this.alert.message = `Detail akun berhasil dikirim ke ${methodText}`;
                this.alert.type = 'success';
                /* eslint-disable @typescript-eslint/no-explicit-any */
            }
            catch (e) {
                this.alert.message = e.message || UNKNOWN_ERROR;
                this.alert.type = 'error';
            }
            finally {
                this.requestingPassword = false;
            }
        },
        clearAlert() {
            this.alert = {
                message: '',
                type: '',
            };
        },
    },
});
